import { BRANDED_COLOURS, GRADIENTS, OREGON_COLOURS, SPIKES_COLOURS, WA_WHITE } from '@constants';

export const FORM_FIELD = {
  TITLE: {
    name: 'title',
    label: 'Title (optional):',
  },
  BACKGROUND_COLOR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [...BRANDED_COLOURS, GRADIENTS['gradient-1'].key, WA_WHITE, ...OREGON_COLOURS, ...SPIKES_COLOURS],
    rules: [{ required: true, message: 'Background colour is required' }],
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);

export const INITIAL_VALUES = {};
